import { ErrorResponse } from "../../../utils/types/generals"

export type DeleteActivity = {
    code: CodeDeleteActivity,
    message: string
} & ErrorResponse

export enum CodeDeleteActivity {
    SUCCESS = '01'
}